/* Career Firewall cart: order bump + one edition per order + one-step upgrade + phone sticky bar. No dependencies.
   Founder decision (15 Oct 2026): no withdrawal waiver in the cart, Checkout works at once for every country. The
   withdrawal_waiver attributes that an earlier visit may have left in the cart are cleared (empty values) and never read. */
(function (global) {
  // One edition per order: "<key>:<qty>:<added_at>," lines of the main product → updates keeping the edition chosen last,
  // at quantity 1. added_at is the _cf_added property written by the buy buttons (CRO audit round 3: the order of
  // cart.items is not documented, newest lines usually come first); without it the first line is taken as the newest.
  function singleEditionUpdates(lines) {
    var parts = String(lines || '').split(',').filter(Boolean).map(function (p, idx) {
      var bits = p.split(':');
      var added = bits.length > 2 ? Number(bits.pop()) || 0 : 0;
      var qty = Number(bits.pop());
      return { key: bits.join(':'), qty: qty, added: added, idx: idx };
    });
    if (parts.length === 0 || (parts.length === 1 && parts[0].qty <= 1)) return null;
    var keep = parts.reduce(function (best, p) {
      if (p.added !== best.added) return p.added > best.added ? p : best;
      return p.idx < best.idx ? p : best;
    }, parts[0]);
    var updates = {};
    parts.forEach(function (p) { updates[p.key] = p === keep ? 1 : 0; });
    return updates;
  }
  global.CFCart = { singleEditionUpdates: singleEditionUpdates };

  if (typeof document === 'undefined') return;
  var root = document.querySelector('[data-cf-cart]');
  var checkout = document.querySelector('[data-cf-checkout]');
  if (!root || !checkout) return;
  var bump = root.querySelector('[data-cf-bump]');
  var mapsVariant = root.getAttribute('data-maps-variant');
  var routeRoot = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  var NOTE_KEY = 'cf-single-edition';
  var BUMP_FOCUS_KEY = 'cf-bump-focus';
  var sticky = document.querySelector('[data-cf-cart-sticky]');

  function url(path) { return routeRoot.replace(/\/$/, '') + path; }
  function post(path, body) {
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function reloadToExtras() {
    global.location.hash = 'cf-cart-extras';
    global.location.reload();
  }

  // A declaration left by an earlier visit (before 15 Oct 2026) is cleared: Shopify would copy it to the order.
  if (root.hasAttribute('data-legacy-waiver')) post('/cart/update.js', { attributes: { withdrawal_waiver: '', withdrawal_waiver_cart: '' } }).catch(function () {});
  var updates = singleEditionUpdates(root.getAttribute('data-edition-lines'));
  if (updates) {
    post('/cart/update.js', { updates: updates })
      .then(function () { try { sessionStorage.setItem(NOTE_KEY, '1'); } catch (e) { /* the note is optional */ } reloadToExtras(); })
      .catch(function () {});
  } else {
    try {
      if (sessionStorage.getItem(NOTE_KEY)) {
        sessionStorage.removeItem(NOTE_KEY);
        var note = root.querySelector('[data-cf-single-note]');
        if (note) note.hidden = false;
      }
    } catch (e) { /* storage blocked */ }
  }
  try {
    if (bump && sessionStorage.getItem(BUMP_FOCUS_KEY)) { sessionStorage.removeItem(BUMP_FOCUS_KEY); bump.focus(); }
  } catch (e) { /* storage blocked */ }

  // CRO mobile review: "Switch to the System" swaps the editions in one step. The System is added first (with _cf_added, so
  // the one-edition rule keeps it even if the next call fails), then the Guide line goes to 0, then one reload to the top of
  // the cart: the buyer never sees both editions and a double total. Any failure of the first call falls back to the native
  // form (snippets/cf-cart-upgrade-form.liquid), which is also the path without JavaScript.
  var upgradeForm = document.getElementById('cf-upgrade');
  if (upgradeForm && typeof fetch === 'function') {
    var upgrading = false;
    upgradeForm.addEventListener('submit', function (e) {
      var guideKey = upgradeForm.getAttribute('data-cf-guide-key');
      var idField = upgradeForm.querySelector('[name="id"]');
      var systemId = idField && Number(idField.value);
      if (!guideKey || !systemId) return;
      e.preventDefault();
      if (upgrading) return;
      upgrading = true;
      var upgradeButton = document.querySelector('[data-cf-upgrade-button]');
      if (upgradeButton) { upgradeButton.setAttribute('aria-disabled', 'true'); upgradeButton.setAttribute('aria-busy', 'true'); }
      var toCart = function () { global.location.assign(url('/cart')); };
      post('/cart/add.js', { items: [{ id: systemId, quantity: 1, properties: { _cf_added: String(Date.now()) } }] })
        .then(function () { return post('/cart/change.js', { id: guideKey, quantity: 0 }).then(toCart, toCart); }, function () {
          upgrading = false;
          if (upgradeButton) { upgradeButton.removeAttribute('aria-disabled'); upgradeButton.removeAttribute('aria-busy'); }
          HTMLFormElement.prototype.submit.call(upgradeForm);
        });
    });
  }

  // CRO mobile review: sticky bar (snippets/cf-cart-sticky.liquid, phones and tablets) with the total and Checkout, shown only
  // while the in-page Checkout is out of view. Its button submits the cart form like #checkout.
  if (sticky && 'IntersectionObserver' in global) {
    var stickyTotal = sticky.querySelector('[data-cf-sticky-total]');
    sticky.hidden = false;
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[entries.length - 1].isIntersecting);
    }).observe(checkout);
    // Dawn refreshes the subtotal .js-contents when a line is removed: keep the bar's total equal to the totals row.
    var footer = document.getElementById('main-cart-footer');
    if (footer && stickyTotal && 'MutationObserver' in global) {
      new MutationObserver(function () {
        var value = footer.querySelector('.totals__total-value');
        if (value && value.textContent.trim() !== stickyTotal.textContent.trim()) stickyTotal.textContent = value.textContent.trim();
      }).observe(footer, { childList: true, subtree: true, characterData: true });
    }
  }

  if (bump && mapsVariant) {
    // CRO audit round 4: aria-disabled instead of disabled, so the focus stays on the box while the cart is saved, and a
    // failed save is announced (role="alert") instead of unticking the box silently.
    var bumpError = root.querySelector('[data-cf-bump-error]');
    var bumpBusy = function () { return bump.getAttribute('aria-disabled') === 'true'; };
    bump.addEventListener('click', function (e) { if (bumpBusy()) e.preventDefault(); });
    bump.addEventListener('change', function () {
      if (bumpBusy()) return;
      bump.setAttribute('aria-disabled', 'true');
      if (bumpError) bumpError.hidden = true;
      var req = bump.checked
        ? post('/cart/add.js', { items: [{ id: Number(mapsVariant), quantity: 1 }] })
        : post('/cart/change.js', { id: Number(mapsVariant), quantity: 0 });
      req.then(function () { try { sessionStorage.setItem(BUMP_FOCUS_KEY, '1'); } catch (e) { /* optional */ } reloadToExtras(); })
        .catch(function () {
          bump.checked = !bump.checked;
          bump.setAttribute('aria-disabled', 'false');
          if (bumpError) bumpError.hidden = false;
          bump.focus();
        });
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
